export class UbicacionAlmacenamiento {

    codigo: number;
    habilitacion: boolean;
    id: string;
    idCompania: string;
    idPais: string;
    idSalesOrg: string;
    idPlanta: string;
    autor: string;
    expoTransferencias: boolean;
    
    descripcion: string;
    nroClienteDireccionEntrega: string;
    nombreClienteDireccionEntrega: string; 
    displayValue: string;
}